import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import processingIcon from "../../../../../assets/design-revamp-company/company-detail-headers/processing-icon.svg";
import { useTranslation } from "react-i18next";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import { getProcessingSoldIntermediateTotal } from "../../../../../apis/Business/ProcessingSoldIntermediateApi";

const ProcessIcon = () => (
  <img
    src={processingIcon}
    alt="Processing Intermediate Icon"
    width={76}
    height={76}
  />
);

const ProcessingSoldHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjProcessing, setTotalObjProcessing] = useState([]);
  const [systemBoundaryProcess, setSystemBoundaryProcess] = useState("");
  useEffect(() => {
    getProcessingSoldIntermediateTotal({
      businessId: businessId,
      setTotalObj: setTotalObjProcessing,
      setSystemBoundaryProcessing: setSystemBoundaryProcess,
    });
  }, [businessId]);

  return (
    <CategoryComponent
      show={show}
      className={`processing-sold-category ${className || ""}`}
      leftBoxProps={{
        icon: <ProcessIcon />,
        title: t("PROCESSING_SOLD_INTERMEDIATE"),
        description: t("PROCESS_INTERMEDIATE_DESC"),
        scopes: [{ scope: "Scope 3", filled: true }],
        isSystemBoundary: true,
        systemBoundary: systemBoundaryProcess,
        setSystemBoundary: setSystemBoundaryProcess,
        businessId: businessId,
        totalObjCategory: totalObjProcessing?.category_name,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: t("EXPENSES"),
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalObjProcessing,
                      totalObjProcessing?.total_expenses
                    ),
                  },
                ],
              },
              {
                subtitle: `${t("EMISSIONS")} (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjProcessing,
                      totalObjProcessing?.total_emissions
                    ),
                    scopes: ["S:3, C:10"],
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjProcessing?.updated_at
          ? formatDate(totalObjProcessing?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default ProcessingSoldHeader;
